import React from "react";
import { useSelector } from "react-redux";

// Totals of a project target for ongoing and completed projects, from
// projectTargets in getProjectDashboardData (rows ONGOING, COMPLETED, TOTAL).
const METRICS = {
  area: {
    title: "Targeted Area Under Irrigation",
    valueKey: "targetedArea",
    filledKey: "withAreaTarget",
    unit: "Acres",
    decimals: 2,
  },
  beneficiaries: {
    title: "Potential Beneficiaries",
    valueKey: "potentialBeneficiaries",
    filledKey: "withBeneficiaries",
    unit: "",
    decimals: 0,
  },
};

const STATUS_COLORS = {
  ONGOING: "#0092CC",
  COMPLETED: "#22C55E",
};

function ProjectTargetsCard({ metric = "area" }) {
  const url = "api/v2/dashboard/getProjectDashboardData";
  const data = useSelector((state) => state.fetch.data[url] || []);
  const config = METRICS[metric] || METRICS.area;

  const rows = Array.isArray(data?.projectTargets) ? data.projectTargets : [];
  const row = (status) => rows.find((r) => r?.status === status) || {};
  const total = row("TOTAL");

  const format = (value) =>
    Number(value || 0).toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: config.decimals,
    });

  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white w-full h-full">
      <div className="flex items-center justify-between text-[#424242] font-interSans text-[.75rem] font-[500] mb-[1.18rem]">
        <span>{config.title}</span>
        {config.unit && (
          <div className="bg-[#D6E1F5] rounded-[.5rem] py-[.125rem] px-[.25rem] max-w-[6.875rem] flex items-center justify-center">
            {config.unit}
          </div>
        )}
      </div>

      <div className="text-[#050505] font-interSans text-[1.5rem] font-[500]">
        {format(total?.[config.valueKey])}
      </div>

      <div className="mt-[1.25rem] flex flex-wrap items-center gap-x-[2.5rem] gap-y-2">
        {["ONGOING", "COMPLETED"].map((status) => (
          <div key={status} className="flex items-center gap-x-[.5rem]">
            <span
              className="inline-block w-[.5rem] h-[.5rem] rounded-full"
              style={{ background: STATUS_COLORS[status] }}
            />
            <span className="text-[#6B7280] font-interSans text-[.75rem] font-[400]">
              {status === "ONGOING" ? "Ongoing" : "Completed"}
            </span>
            <span className="text-[#050505] font-interSans text-[.875rem] font-[500]">
              {format(row(status)?.[config.valueKey])}
            </span>
          </div>
        ))}
      </div>

      {/* Projects with nothing entered add 0, so say how complete the total is. */}
      {total?.projects > 0 && (
        <div className="mt-[1rem] text-[#9CA3AF] font-interSans text-[.6875rem] font-[400]">
          Based on {total?.[config.filledKey] ?? 0} of {total?.projects} projects
        </div>
      )}
    </div>
  );
}

export default ProjectTargetsCard;
